import 'Styles/templates/product.scss'
import '../snippets/match-media'
import '../snippets/zoom'
import { Api } from '../snippets/api'
import * as cart from '../snippets/cart'
import $ from 'cash-dom'
import { checkMatch } from '../snippets/match-media'
import { initCarousel } from '../snippets/carousel'

$(() => {
  const $els = {
    variantInput: $('.variant-input'),
    variantCarousel: $('.variant-carousel'),
    variantImages: $('[data-variant-images]'),
    variantThumbs: $('.variant-thumbs'),
    variantThumb: $('.variant-thumb'),
    firstThumb: $('.variant-thumb:first-child'),
    galleryCarousel: $('.gallery-carousel'),
    productCarousel: $('.product-carousel'),
    carouselNext: $('.carousel-next'),
    carouselPrev: $('.carousel-prev'),
    galleryNext: $('.gallery-next'),
    galleryPrev: $('.gallery-prev'),
    galleryIndex: $('.gallery-index'),
    viewAllReviews: $('.view-all-reviews'),
    productDetails: $('.product-details'),
    addToCart: $('.add-to-cart-btn'),
    dropdown: $('.product__dropdown-trigger'),
  }

  // init gallery carousel
  if ($els.galleryCarousel.length > 0) {
    const gallery = new Flickity('.gallery-carousel', {
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      contain: true,
      on: {
        ready: () => {
          const height = $els.galleryCarousel.find('.is-selected').height()
          $els.galleryCarousel.find('.flickity-viewport').height(height)
        },
      },
    })
    const count = $els.galleryCarousel.data('item-count')
    $els.galleryNext.on('click', () => {
      const next = gallery.selectedIndex + 1
      const nextNext = next + 1
      if (nextNext <= count - 1) {
        $els.galleryIndex.text(nextNext === count - 1 ? count - 1 : nextNext)
        gallery.next()
      }
    })
    $els.galleryPrev.on('click', () => {
      if (gallery.selectedIndex > 0) {
        $els.galleryIndex.text(gallery.selectedIndex)
        gallery.previous()
      }
    })
  }

  // init product carousel
  initCarousel('.product-carousel')

  // init variant carousels
  $els.variantCarousel.each(function (i) {
    const $this = $(this)

    let flickity
    const init = (config) => {
      if (flickity) {
        flickity.destroy()
      }
      flickity = new Flickity(
        `.variant-carousel-${i + 1}`,
        {
          ...config,
          on: {
            ready: function () {
              if (this.cells?.length === 1) {
                $this.siblings('.mobile-gallery-prev').addClass('visually-hidden')
                $this.siblings('.mobile-gallery-next').addClass('visually-hidden')
              } else {
                $this.siblings('.mobile-gallery-prev').removeClass('visually-hidden')
                $this.siblings('.mobile-gallery-next').removeClass('visually-hidden')
              }
            }
          }
        }
      )
      $els.variantThumbs.on('click', '.variant-thumb', function () {
        const index = $(this).index()
        $(this)
          .siblings('button')
          .each(function () {
            $(this).removeClass('opacity-100').addClass('opacity-50')
          })
        $(this).removeClass('opacity-50').addClass('opacity-100')
        flickity.select(index, false, true)
      })

      const updateThumb = (e, direction) => {
        const idx = flickity.selectedIndex
        const $curr = $(e.currentTarget)
        const $children = $curr.siblings('div').find('button')
        const total = $children.length
        const last = total - 4
        const next = idx + 1 === total ? 0 : idx + 1
        const prev = idx - 1 === -1 ? total - 1 : idx - 1
        const inc = direction === 'inc'
        const $next = inc ? next : prev
        const $inner = $($curr.siblings('div').children()[0])

        $inner.css(
          `transform`,
          `translateY(-${$next * 80 > last * 80 ? last * 80 : $next * 80}px)`
        )
        $els.variantThumb.removeClass('opacity-100').addClass('opacity-50')
        $($children[$next]).removeClass('opacity-50').addClass('opacity-100')
        flickity.select($next, false, true)
      }

      $els.carouselNext.on('click', (e) => {
        updateThumb(e, 'inc')
      })
      $els.carouselPrev.on('click', (e) => {
        updateThumb(e, 'dec')
      })
      $this.siblings('.mobile-gallery-prev').on('click', (e) => {
        flickity.previous()
      })
      $this.siblings('.mobile-gallery-next').on('click', (e) => {
        flickity.next()
      })
      $els.variantInput.on('click', (e) => {
        $els.variantThumb.removeClass('opacity-100').addClass('opacity-50')
        $els.firstThumb.addClass('opacity-100').removeClass('opacity-50')
        flickity.select(0, false, true)
      })
    }

    checkMatch({
      mq: '(min-width: 1024px)',
      onMatch: () => {
        init({
          prevNextButtons: false,
          freeScroll: false,
          draggable: false,
          pageDots: false,
          initialIndex: 0,
          accessibility: false
        })
      },
      onUnmatch: () => {
        init({
          prevNextButtons: true,
          freeScroll: false,
          draggable: true,
          pageDots: false,
          wrapAround: true,
          initialIndex: 0,
        })
      },
    })
  })

  $els.dropdown.on('click', (e) => {
    const $this = $(e.currentTarget)
    const $sib = $this.siblings('div')
    $sib.toggleClass('active')
    if ($sib.hasClass('active')) {
      $this.find('svg').css('transform', 'rotate(180deg)')
    } else {
      $this.find('svg').css('transform', 'rotate(0deg)')
    }
  })

  // view all reviews click
  $els.viewAllReviews.on('click', () => {
    const top = $('[id*="__yotpo-reviews"]').first().offset().top
    window.scroll({ top, behavior: 'smooth' })
  })

  // add to cart
  $els.addToCart.on('click', async (e) => {
    const id = e.target.dataset.variantId
    cart.openCart()
    document.dispatchEvent(new CustomEvent('cartOpened'))
    await Api.addProduct(id)
    cart.updateCart()
    document.dispatchEvent(new CustomEvent('cartUpdated'))
  })

  setTimeout(() => {
    $els.variantThumbs
      .removeClass('translate-y-4 opacity-0')
      .addClass('translate-y-0 opacity-100')
  }, 0)
  setTimeout(() => {
    $els.variantImages
      .removeClass('translate-y-4 opacity-0')
      .addClass('translate-y-0 opacity-100')
  }, 200)
  setTimeout(() => {
    $els.productDetails
      .removeClass('translate-y-4 opacity-0')
      .addClass('translate-y-0 opacity-100')
  }, 400)

  $('.complete-look__cta').on('click', async (e) => {
    const button = $(e.currentTarget)
    const id = button.data('id')
    button.addClass('active')
    await Api.addProduct(id)
    await cart.updateCart()
    document.dispatchEvent(new CustomEvent('cartUpdated'))
    button.removeClass('active')
  })

  const renderArrows = (scrolled) => {
    const $list = $('.complete-look__list')

    if ($list[0]) {
      if (scrolled > 0) {
        $('.complete-look__arrow-left').addClass('active')
      } else {
        $('.complete-look__arrow-left').removeClass('active')
      }
      if (scrolled === $list[0].scrollWidth - $list[0].clientWidth) {
        $('.complete-look__arrow-right').removeClass('active')
      } else {
        $('.complete-look__arrow-right').addClass('active')
      }
    }
  }

  $('.complete-look__list').on('scroll', (e) => {
    renderArrows($(e.currentTarget)[0].scrollLeft)
  })

  $('.complete-look__arrow-right').on('click', (e) => {
    const list = document.querySelector('.complete-look__list')
    const scrolledLeft = list.scrollLeft
    list.scrollLeft = scrolledLeft + 250
  })

  $('.complete-look__arrow-left').on('click', (e) => {
    const list = document.querySelector('.complete-look__list')
    const scrolledLeft = list.scrollLeft
    list.scrollLeft = scrolledLeft - 250
  })

  renderArrows()

  window.addEventListener('resize', (e) => {
    renderArrows()
  })

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (addedNode) {
        if (
          addedNode.classList &&
          addedNode.classList.contains('affirm-modal-trigger')
        ) {
          if (addedNode.closest('.affirm-button')) {
            addedNode.innerText = ''
          }
        }
        if (
          addedNode.classList &&
          addedNode.classList.contains('yotpo-no-reviews')
        ) {
          const all = document.querySelector('.view-all-reviews')
          if (all) {
            all.remove()
          }
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
})
